if (!customElements.get("details-disclosure")) {
  class DetailsDisclosure extends HTMLElement {
    constructor() {
      super();
      this.mainDetailsToggle = this.querySelector("details");
      this.summary = this.mainDetailsToggle.querySelector("summary");
      this.content =
        this.mainDetailsToggle.querySelector("summary").nextElementSibling;
      this.button = this.mainDetailsToggle.querySelector(".icon-caret");
      this.animation = null;
      // Store if the element is closing
      this.isClosing = false;
      // Store if the element is expanding
      this.isExpanding = false;
      this.summary.addEventListener("click", (e) => this.onClick(e));
    }

    onClick(e) {
      e.preventDefault();
      this.mainDetailsToggle.style.overflow = "hidden";
      if (this.isClosing || !this.mainDetailsToggle.open) {
        this.open();
      } else if (this.isExpanding || this.mainDetailsToggle.open) {
        this.close();
      }
    }

    close() {
      this.isClosing = true;
      const startHeight = `${this.mainDetailsToggle.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight}px`;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      this.animation = this.mainDetailsToggle.animate(
        {
          height: [startHeight, endHeight],
        },
        {
          duration: 225,
          easing: "ease",
        }
      );

      this.animation.onfinish = () => this.onAnimationFinish(false);
      // If the animation is cancelled, isClosing variable is set to false
      this.animation.oncancel = () => (this.isClosing = false);

      this.button.classList.remove("icon-caret--active");

      this.mainDetailsToggle
        .querySelector("summary")
        .setAttribute("aria-expanded", false);
    }

    open() {
      // Apply a fixed height on the element
      this.mainDetailsToggle.style.height = `${this.mainDetailsToggle.offsetHeight}px`;
      // Force the [open] attribute on the details element
      this.mainDetailsToggle.open = true;
      // Wait for the next frame to call the expand function
      window.requestAnimationFrame(() => this.expand());
    }

    expand() {
      this.isExpanding = true;
      const startHeight = `${this.mainDetailsToggle.offsetHeight}px`;
      const endHeight = `${
        this.summary.offsetHeight + this.content.offsetHeight
      }px`;

      console.log(startHeight, endHeight);
      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      this.animation = this.mainDetailsToggle.animate(
        {
          height: [startHeight, endHeight],
        },
        {
          duration: 225,
          easing: "ease",
        }
      );
      this.animation.onfinish = () => this.onAnimationFinish(true);
      // If the animation is cancelled, isExpanding variable is set to false
      this.animation.oncancel = () => (this.isExpanding = false);

      this.button.classList.add("icon-caret--active");

      this.mainDetailsToggle
        .querySelector("summary")
        .setAttribute("aria-expanded", true);
    }

    onAnimationFinish(open) {
      this.mainDetailsToggle.open = open;
      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      this.mainDetailsToggle.style.height =
        this.mainDetailsToggle.style.overflow = "";
    }
  }

  customElements.define("details-disclosure", DetailsDisclosure);
}
